import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
// import styled from 'styled-components';

import { contentPush as cpProps } from '../../../../types'
import Button from '../../../Button'
import { Form, Input, Headings, Padding, Column } from '../../..'
import { Frame, FrameContent } from './Form.style'
import { DateUtils } from '../../../../utils'
import { withSize } from '../../../utils'

const { FormGroup, FormHeader, Label } = Form

class Confirmation extends PureComponent {
    static propTypes = {
        errorNotes: PropTypes.string,
        isNew: PropTypes.bool,
        isWorking: PropTypes.bool,
        onBackForm: PropTypes.func,
        onChangeNotes: PropTypes.func,
        onSubmit: PropTypes.func,
        values: PropTypes.shape(cpProps),
        isMobile: PropTypes.bool,
    }

    static defaultProps = {
        errorNotes: null,
        isNew: false,
        isWorking: false,
        onBackForm: () => null,
        onChangeNotes: () => null,
        onSubmit: () => null,
        values: {},
        isMobile: false,
    }

    get submitLabel() {
        const {
            isNew,
            values: { purchase_order },
        } = this.props

        if (!purchase_order) {
            return 'Save Draft'
        }

        return isNew ? 'Create' : 'Edit'
    }

    render() {
        const {
            errorNotes,
            isNew,
            isWorking,
            onBackForm,
            onChangeNotes,
            onSubmit,
            values: {
                countries: valueCountry,
                date_end: valueExpiryDate,
                date_start: valueGoLiveDate,
                group: valueGroup,
                level_required: valueLevel,
                name: valueName,
                notes: valueNotes,
                purchase_order: valuePurchaseOrder,
            },
            isMobile,
        } = this.props

        return (
            <Frame>
                <FrameContent>
                    <Form>
                        <FormHeader>{isNew ? `Create Content Push ${valueName}` : `Edit Content Push ${valueName}`}</FormHeader>
                        <FormGroup>
                            <Column>
                                <div>
                                    <Headings.H2>Name</Headings.H2>
                                    <Padding right>{valueName}</Padding>
                                </div>
                                <div>
                                    <Headings.H2>Country</Headings.H2>
                                    <Padding right>{valueCountry.join(' ')}</Padding>
                                </div>
                                <div>
                                    <Headings.H2>Starts on</Headings.H2>
                                    <Padding right>{DateUtils.formatUIShort(valueGoLiveDate)}</Padding>
                                </div>
                                <div>
                                    <Headings.H2>Ends on</Headings.H2>
                                    <Padding right>{DateUtils.formatUIShort(valueExpiryDate)}</Padding>
                                </div>
                            </Column>
                            <Column>
                                <div>
                                    <Headings.H2>Purchase Order</Headings.H2>
                                    <Padding right>{valuePurchaseOrder}</Padding>
                                </div>
                                <div>
                                    <Headings.H2>Group</Headings.H2>
                                    <Padding right>{valueGroup}</Padding>
                                </div>
                                <div>
                                    <Headings.H2>Level</Headings.H2>
                                    <Padding right>{valueLevel}</Padding>
                                </div>
                            </Column>
                        </FormGroup>
                        <FormGroup title="Notes">
                            <Label id="notes" error={errorNotes}>
                                <Input
                                    id="notes"
                                    name="notes"
                                    type="textarea"
                                    error={!!errorNotes}
                                    onChange={onChangeNotes}
                                    value={valueNotes}
                                    size={isMobile ? 'md' : 'lg'}
                                />
                            </Label>
                        </FormGroup>
                        <FormGroup>
                            <Column right width="100%">
                                <Button onClick={onBackForm} theme="light">
                                    Go Back
                                </Button>
                                <Button theme={isWorking ? 'loading' : 'primary'} onClick={onSubmit}>
                                    {isWorking ? '...' : this.submitLabel}
                                </Button>
                            </Column>
                        </FormGroup>
                    </Form>
                </FrameContent>
            </Frame>
        )
    }
}

export default withSize(Confirmation)
